import { Link, useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from 'react'
import Archives from '../components/archives'


export default function Sidebar({ props }) {

  const data = useStaticQuery(graphql`
  query SideBarQuery {
    allFile(filter: { extension: { regex: "/(jpg|jpeg|png|gif)/" } }) {
      edges {
        node {
          relativePath
          childImageSharp {
            gatsbyImageData(width: 200)
          }
        }
      }
    },
    site {
      siteMetadata {
        author {
          name
          summary
        }
        features {
          name
          description
          img
          link
          alt
        }
      }
    }
  }
  `)

  return (
        <aside className="col-xs-8 offset-xs-2 offset-sm-0 col-sm-3 col-md-2 mt-5 mt-sm-0">
          {data.site.siteMetadata.features.map((feat, i) => (
            <div key={i} className="row mt-2 mt-sm-0">
              <h2 className="titre">{feat.name}</h2>
              <blockquote>{feat.description}</blockquote>
              <a href={feat.link} title={feat.alt}><GatsbyImage image={getImage(data.allFile.edges.find(value => value.node.relativePath === feat.img).node)} className="img-fluid" alt={feat.alt} width={200}/></a>
            </div>
          ))}
          <Archives/>
    </aside>
  )
}
